import React from 'react'

import Drawer from "react-drag-drawer";

import AudioPlayer from './components/AudioPlayer';

import './styles.css'
import clsx from "clsx";
import {BsX} from "react-icons/bs";

const AudioPlayerModal = ({
    isOpen,
    audioUrl,
    bookTitle,
    bookCover,
    authorName,
    onHideModal,
    narratorName,
}) => {
    return (
        <Drawer modalElementClass="relative flex flex-col" dontApplyListeners={true} open={isOpen} onRequestClose={onHideModal}>
            <button onClick={onHideModal} className="ml-auto">
                <BsX className="w-12 h-12 text-white" />
            </button>
            <div className='modal-body'>
                <div className='modal-content'>
                    <div
                      className={clsx("book-cover mx-auto mb-2")}
                      style={{ backgroundImage: `url(${bookCover})` }}
                    />

                    <p className="text-center font-medium">{bookTitle}</p>
                    <p className="text-pallet-4 text-center -mt-2">{authorName}</p>


                    <AudioPlayer audioUrl={audioUrl} />

                    <div className='text-center mt-4'>
                        <p className='text-sm ml-1 text-pallet-4'>Narração:</p>
                        <p className='text-sm text-secondary-color' style={{ padding: '0 0 0 8px' }}>{narratorName}</p>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default AudioPlayerModal
